// logger.ts
export const LogLevel = {
    NONE: 0,
    ERROR: 1,
    WARN: 2,
    INFO: 3,
    DEBUG: 4
  } as const;
  
  type LogLevelType = typeof LogLevel[keyof typeof LogLevel];
  
  // Set based on environment
  export const CURRENT_LOG_LEVEL: LogLevelType = 
    process.env.NODE_ENV === 'production' ? LogLevel.ERROR : LogLevel.DEBUG;
  
  export const Logger = {
    error: (message: () => any): void => {
      if (CURRENT_LOG_LEVEL >= LogLevel.ERROR) console.error(message());
    },
    
    warn: (message: () => any): void => {
      if (CURRENT_LOG_LEVEL >= LogLevel.WARN) console.warn(message());
    },
    
    info: (message: () => any): void => {
      if (CURRENT_LOG_LEVEL >= LogLevel.INFO) console.info(message());
    },
    
    debug: (message: () => any): void => {
      if (CURRENT_LOG_LEVEL >= LogLevel.DEBUG) console.log(message());
    }
  };
  
  // Usage
  // Logger.debug(() => `Player ${id} ejected ${amount} resources at ${x}, ${y}`);